
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/table/widget",
      function () {
        return require("private-next-pages/bundesliga/table/widget/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/table/widget"])
      });
    }
  